import {useCallback, useContext} from "react";
import useUserRights from "@hooks/useUserRights";
import { GlobalContext } from "@tools/globalContext";

const useLinkGenerator = () => {
    const { findPath } = useUserRights();
    const { user } = useContext(GlobalContext);

    const partyLink = useCallback((item: {id?: string}, tab?: string): string|null => {
        const mainPath = findPath("parties", item.id || "")
        return mainPath ? `${mainPath}/${item.id || ""}${tab ? `/${tab}` : ""}` : null
    }, [findPath]);

    const contractLink = useCallback((item: {id?: string}, tab?: string): string|null => {
        const mainPath = findPath("contracts", item.id || "")
        return mainPath ? `${mainPath}/${item.id || ""}${tab ? `/${tab}` : ""}` : null
    }, [findPath]);

    const userLink = useCallback((item: {id?: string}, tab?: string): string|null => {
        const mainPath = findPath("users", item.id || "")
        return mainPath ? `${mainPath}/${item.id || ""}${tab ? `/${tab}` : ""}` : null
    }, [findPath, user]);

    const businessObjectLink = useCallback((item: {id?: string}, tab?: string): string|null => {
        const mainPath = findPath("businessObjects", item.id || "")
        return mainPath ? `${mainPath}/${item.id || ""}${tab ? `/${tab}` : ""}` : null
    }, [findPath, user]);

    const filesAndFoldersLink = useCallback((item: {id?: string}, tab?: string): string|null => {
        const mainPath = findPath("filesAndFolders", item.id || "")
        return mainPath ? `${mainPath}/${item.id || ""}${tab ? `/${tab}` : ""}` : null
    }, [findPath, user]);

    const invoiceLink = useCallback((item: {id?: string}, tab?: string): string|null => {
        const mainPath = findPath("invoices", item.id || "")
        return mainPath ? `${mainPath}/${item.id || ""}${tab ? `/${tab}` : ""}` : null
    }, [findPath, user]);

    const characteristicLink = useCallback((item: {id?: string}, tab?: string): string|null => {
        return  null
    }, [findPath, user]);

    const draftLink = useCallback((item: {id?: string}, tab?: string): string|null => {
        const mainPath = findPath("drafts", item.id || "")
        return mainPath ? `${mainPath}/${item.id || ""}${tab ? `/${tab}` : ""}` : null
    }, [findPath, user]);

    const logLink = useCallback((item: {id?: string}, tab?: string): string|null => {
        const mainPath = findPath("logs", item.id || "")
        return mainPath ? `${mainPath}/${item.id || ""}${tab ? `/${tab}` : ""}` : null
    }, [findPath, user]);

    return {
        invoiceLink,
        partyLink,
        contractLink,
        userLink,
        businessObjectLink,
        filesAndFoldersLink,
        characteristicLink,
        draftLink,
        logLink
    }
}


export default useLinkGenerator
